module.exports = __webpack_public_path__ + "az.svg?c460a87640d0ff137c88b6c589177664";